import { CommonModule } from '@angular/common';
import {
    Component,
    effect,
    ElementRef,
    EventEmitter,
    input,
    Output,
    QueryList,
    ViewChildren,
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-verification-code',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, FormsModule],
    templateUrl: './verification-code.component.html',
    styleUrl: './verification-code.component.scss',
})
export class VerificationCodeComponent {
    @ViewChildren('inputElement')
    inputs: QueryList<ElementRef<HTMLInputElement>>;
    enable = input.required<boolean>();
    reset = input.required<boolean>();
    codeLength = 6;
    codeControls: FormControl[] = [];

    @Output() codeCompleted = new EventEmitter<string>();

    constructor() {
        for (let i = 0; i < this.codeLength; i++) {
            this.codeControls.push(new FormControl(''));
        }

        effect(() => {
            if (this.reset()) {
                this.codeControls.forEach((control) => control.setValue(''));
                this.focusFirstInput();
            }
        });
    }

    ngOnChanges(): void {
        if (!this.enable()) {
            this.codeControls.forEach((control) => control.disable());
        } else {
            this.codeControls.forEach((control) => control.enable());

            setTimeout(() => {
                this.focusFirstInput();
            }, 200);
        }
    }

    // Timeout only for subtle delay animation
    focusFirstInput() {
        const firstInput = this.inputs.toArray()[0];
        firstInput?.nativeElement.focus();
    }

    onInput(event: any, index: number) {
        const input = event.target;
        let value = input.value;

        // Only allow numeric input
        if (value.length > 1) {
            value = value.slice(0, 1);
            input.value = value;
        }

        // Move to next input if a digit is entered
        if (value && index < this.codeLength - 1) {
            const nextInput = input.nextElementSibling as HTMLInputElement;
            if (nextInput) nextInput.focus();
        }

        this.emitCode();
    }

    onKeyDown(event: KeyboardEvent, index: number) {
        const input = event.target as HTMLInputElement;

        if (event.key === 'Backspace' && !input.value && index > 0) {
            const prevInput = input.previousElementSibling as HTMLInputElement;
            if (prevInput) prevInput.focus();
        }
    }

    emitCode() {
        const code = this.codeControls.map((c) => c.value).join('');
        if (code.length === this.codeLength) {
            this.codeCompleted.emit(code);
        }
    }
}
